import { InjectionToken } from '@angular/core';
import { Routes } from '@angular/router';

export const APP_ROUTES = new InjectionToken<Routes>('aumicoRoutes');

export interface AumicoUser {
    name: string;
    userId: string;
    roles: string[];
    // Should be a link to a image
    avatarImgSrc?: string;
    language: string;
}

export interface IBackNavOptions {
    prefix?: string;
    label?: string;
    icon?: string;
    hidden: boolean;
}

export interface IProceedNavOptions {
    prefix?: string;
    label?: string;
    disabled: boolean;
}
